module.exports = __webpack_public_path__ + "static/img/phone_code.04178a1b.svg";